import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { CommonService } from '../../services/common/common.service';
import { AuthService } from '../../services/auth/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { filter } from 'rxjs/operators';
import { DeviceTypeMgmt, IoTManagementAdmin, SoftwareDeployment, SoftwareManagement, UserManagement } from '../../constants/permissions';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})

export class MenuComponent implements OnInit {
  menuExpanded = false;
  menuClass = false;
  isExpanded = false;
  requestInProgress = false;
  allMenuList: Array<any> = [];
  activeMenu: string = "";
  permissions: Array<any> = [];

  constructor(
    private common: CommonService,
    public router: Router,
    public dialog: MatDialog,
    public authService: AuthService) {
    this.authService.permissions$.subscribe(
      (permissionsList: any) => {
        this.permissions = permissionsList;
        if (this.permissions && this.permissions.length) {
          this.getAllMenuList();
        }
      });
  }

  //sidebar toggle
  toggleMenu() {
    this.menuExpanded = !this.menuExpanded;
    this.menuClass = !this.menuClass;
  }

  // Make the sidebar toggle
  toggle() {
    this.isExpanded = !this.isExpanded;
    this.common.setData(this.isExpanded);
  }

  //get value from header menu to toggle
  ngOnInit() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.activeMenu = event.url;
    });
    this.common.sharedData$.subscribe(
      (sharedData: any) => (this.isExpanded = sharedData)
    );
    this.common.requestInProgress$.subscribe(
      (progressData: any) => (this.requestInProgress = progressData)
    );
  }

  getAllMenuList() {
    this.allMenuList = [
      {
        id: 1, menu: 'Home',
        svgIcon: '../assets/menu-icons/dashboard.svg',
        isDisabled: true,
        isVisible: true,
        routeComponentName: 'dashboard',
        submenu: [],
      },
      {
        id: 2, menu: 'Device Management',
        isDisabled: false,
        isVisible: true, // always visible as hub search view permission not available
        svgIcon: '../assets/menu-icons/device-management.svg',
        subRoutes: ['packageManagment/uploadPackage', 'packageManagment/CreateDeploymentProfile', 'packageManagment/deployPackages', 'packageManagment/deviceSearch', 'deviceManagement/multipleDeviceTwin'],
        submenu: [
          { id: 1, name: 'Upload Software', routeComponentName: 'packageManagment/uploadPackage', icon: '../assets/menu-icons/upload-packages.svg', activeIcon: '../assets/menu-icons/upload-packages-active.svg', isVisible: this.common.hasPermission(SoftwareManagement.UploadSoftwareView) },
          { id: 2, name: 'Deployment Profile', routeComponentName: 'packageManagment/CreateDeploymentProfile', icon: '../assets/menu-icons/deployment-profile.svg', activeIcon: '../assets/menu-icons/deployment-profile-active.svg', isVisible: this.common.hasPermission(SoftwareManagement.CreateDeploymentProfileView) },
          { id: 3, name: 'Deploy Software', routeComponentName: 'packageManagment/deployPackages', icon: '../assets/menu-icons/package-deployment.svg', activeIcon: '../assets/menu-icons/package-deployment-active.svg', isVisible: this.common.hasPermission(SoftwareDeployment.DeploySoftwareView) },
          { id: 4, name: 'Device Search', routeComponentName: 'packageManagment/deviceSearch', icon: '../assets/menu-icons/package-management.svg', activeIcon: '../assets/menu-icons/hub-search-property-active.svg', isVisible: this.common.hasPermission(SoftwareDeployment.DeviceSearchView) },
          { id: 5, name: 'Multiple Device Twin Mgmt', routeComponentName: 'deviceManagement/multipleDeviceTwin', icon: '../assets/menu-icons/device-management.svg', activeIcon: '../assets/menu-icons/device-management-active.svg', isVisible: this.common.hasPermission(IoTManagementAdmin.ViewMultipleTwinUpdates) }
        ]
      },
      {
        id: 3, menu: 'Administration',
        isDisabled: false,
        isVisible: this.common.hasPermission(UserManagement.Create) || this.common.hasPermission(UserManagement.Edit) || this.common.hasPermission(UserManagement.Delete) || this.common.hasPermission(DeviceTypeMgmt.DeviceTypeView), // viewusermgmt permission not available
        svgIcon: '../assets/menu-icons/adminstration.svg',
        subRoutes: ['userManagement/users', 'devices/devicetypes'],
        submenu: [
          { id: 1, name: 'User Permissions', routeComponentName: 'userManagement/users', icon: '../assets/menu-icons/group-3.svg', activeIcon: '../assets/menu-icons/group-3-active.svg', isVisible: this.common.hasPermission(UserManagement.Create) || this.common.hasPermission(UserManagement.Edit) || this.common.hasPermission(UserManagement.Delete) },
          { id: 2, name: 'Device Type', routeComponentName: 'devices/devicetypes', icon: '../assets/menu-icons/device-type.svg', activeIcon: '../assets/menu-icons/device-type-active.svg', isVisible: this.common.hasPermission(DeviceTypeMgmt.DeviceTypeView) },
          { id: 3, name: 'Deployment Approval', routeComponentName: 'packageManagment/deployapprove', icon: '../assets/menu-icons/device-type.svg', activeIcon: '../assets/menu-icons/device-type-active.svg', isVisible: this.common.hasPermission(SoftwareDeployment.DeploySoftwareApprove) }
        ]
      }
    ]
  }

  routeComponent(routeValue: any) {
    this.isExpanded = false;
    this.router.navigateByUrl(routeValue);
  }

  isRouteExists(subRoutes: any = []) {
    let isExist = false;
    for (let subRoute of subRoutes){
      if (this.router.url.includes(subRoute)) isExist = true;
    }
    return isExist;
  }
}
